// File: src/views/Impact.js

import React from 'react';
import styles from './Impact.module.css';
import ImpactHero from '../components/impact/ImpactHero';
import ImpactInfographic from '../components/impact/ImpactInfographic';
import EnvironmentalStats from '../components/impact/EnvironmentalStats';
import MarketStats from '../components/impact/MarketStats';

function Impact() {
  return (
    <div className={styles.page}>
      <ImpactHero />
      <ImpactInfographic />
      {/* <EnvironmentalStats /> */}
      {/* <MarketStats /> */}
    </div>
  );
}

export default Impact;